export default "/_next/static/images/ad1-54536f9d2407bc5d82f5ef98678af45e.png";